import {
  ValidStrategyMatrices,
  IStrategyMatrixOption,
  IMatrixRowOrColumn,
  ISelectOption,
  RiskyAuditLevels,
  ConditionTypes,
} from 'apps/marketplace/components/rfp/types/strategyManager'

export const strategyMatrixOptions: IStrategyMatrixOption[] = [
  {
    label: 'Desirability by PU Market',
    value: ValidStrategyMatrices.desirabilityToPickupMarket,
  },
  {
    label: 'Equipment by PU Market',
    value: ValidStrategyMatrices.equipmentToPickupMarket,
  },
  {
    label: 'Cost % DAT',
    value: ValidStrategyMatrices.lengthOfHaulToCostPctDat7,
  },
  {
    label: 'Vol by Low Desir',
    value: ValidStrategyMatrices.volumeToDesirabilityLow,
  },
  {
    label: 'Vol by Med Desir',
    value: ValidStrategyMatrices.volumeToDesirabilityMedium,
  },
  {
    label: 'Vol by High Desir',
    value: ValidStrategyMatrices.volumeToDesirabilityHigh,
  },
  {
    label: 'Vol by Length of Haul',
    value: ValidStrategyMatrices.volumeToLengthOfHaul,
  },
]

export const volumeByLengthOfHaulRows: IMatrixRowOrColumn[] = [
  {
    label: 'Very High Vol',
    value: 'veryHigh',
  },
  {
    label: 'High Vol',
    value: 'high',
  },
  {
    label: 'Med Vol',
    value: 'medium',
  },
  {
    label: 'Low Vol',
    value: 'low',
  },
]

export const volumeByLengthOfHaulColumns: IMatrixRowOrColumn[] = [
  {
    label: 'City',
    value: 'city',
  },
  {
    label: 'Short',
    value: 'short',
  },
  {
    label: 'Mid',
    value: 'mid',
  },
  {
    label: 'Tweener',
    value: 'tweener',
  },
  {
    label: 'Long',
    value: 'long',
  },
]

export const desirabilityByPickupMarketRows: IMatrixRowOrColumn[] = [
  {
    label: 'High Desirability',
    value: 'high',
  },
  {
    label: 'Med Desirability',
    value: 'medium',
  },
  {
    label: 'Low Desirability',
    value: 'low',
  },
]

export const desirabilityByPickupMarketColumns: IMatrixRowOrColumn[] = [
  {
    label: 'Top PU Market',
    value: 'topPickupMarket',
  },
  {
    label: 'Not Top PU Market',
    value: 'notTopPickupMarket',
  },
]

export const equipmentToPickupMarketRows: IMatrixRowOrColumn[] = [
  {
    label: '53 Van',
    value: '53Van',
  },
  {
    label: '53 Reefer',
    value: '53Reefer',
  },
]

export const equipmentToPickupMarketColumns: IMatrixRowOrColumn[] = [
  {
    label: 'Top PU Market',
    value: 'topPickupMarket',
  },
  {
    label: 'Not Top PU Market',
    value: 'notTopPickupMarket',
  },
]

export const volumeToDesirabilityRows: IMatrixRowOrColumn[] = [
  {
    label: 'Very High Vol',
    value: 'veryHigh',
  },
  {
    label: 'High Vol',
    value: 'high',
  },
  {
    label: 'Med Vol',
    value: 'medium',
  },
  {
    label: 'Low Vol',
    value: 'low',
  },
]

export const volumeToDesirabilityLowColumns: IMatrixRowOrColumn[] = [
  {
    label: '0',
    value: '0',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
]

export const volumeToDesirabilityMediumColumns: IMatrixRowOrColumn[] = [
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
]

export const volumeToDesirabilityHighColumns: IMatrixRowOrColumn[] = [
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
  {
    label: '10',
    value: '10',
  },
]

export const lengthOfHaulToCostPctDat7Rows: IMatrixRowOrColumn[] = [
  {
    label: 'Cost % DAT',
    value: 'costPctDat7',
  },
]

export const lengthOfHaulToCostPctDat7Columns: IMatrixRowOrColumn[] = [
  {
    label: 'City',
    value: 'city',
  },
  {
    label: 'Short',
    value: 'short',
  },
  {
    label: 'Mid',
    value: 'mid',
  },
  {
    label: 'Tweener',
    value: 'tweener',
  },
  {
    label: 'Long',
    value: 'long',
  },
]

export const equipmentOptions: ISelectOption[] = [
  {
    label: '53 Van',
    value: '53_van',
  },
  {
    label: '53 Reefer',
    value: '53_reefer',
  },
  {
    label: '53 Flatbed',
    value: '53_flatbed',
  },
]

export const riskyAuditLevelOptions: ISelectOption[] = [
  {
    label: 'Risk Level 1',
    value: RiskyAuditLevels.level1,
  },
  {
    label: 'Risk Level 2',
    value: RiskyAuditLevels.level2,
  },
  {
    label: 'Risk Level 3',
    value: RiskyAuditLevels.level3,
  },
  {
    label: 'Risk Level 4',
    value: RiskyAuditLevels.level4,
  },
  {
    label: 'Risk Level 5',
    value: RiskyAuditLevels.level5,
  },
  {
    label: 'Risk Level 6',
    value: RiskyAuditLevels.level6,
  },
  {
    label: 'Manual Audit',
    value: RiskyAuditLevels.manualAudit,
  },
]

export const conditionOptions: ISelectOption[] = [
  {
    label: 'Equal to',
    value: ConditionTypes.equal,
  },
  {
    label: 'Greater than',
    value: ConditionTypes.greaterThan,
  },
  {
    label: 'Less than',
    value: ConditionTypes.lessThan,
  },
  {
    label: 'Greater than or equal to',
    value: ConditionTypes.greaterThanOrEqualTo,
  },
  {
    label: 'Less than or equal to',
    value: ConditionTypes.lessThanOrEqualTo,
  },
]
